import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../../style/theme';
import Uno from './ModelCanvasTab/Uno';
import Dos from './ModelCanvasTab/Dos';
import Tres from './ModelCanvasTab/Tres';
import Cuatro from './ModelCanvasTab/Cuatro';
import Cinco from './ModelCanvasTab/Cinco';
import Seis from './ModelCanvasTab/Seis';
import Siete from './ModelCanvasTab/Siete';
import Ocho from './ModelCanvasTab/Ocho';
import Nueve from './ModelCanvasTab/Nueve';

const Content = Layout;

const SUGMDTabs = () => {
  // ACTIVADO
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others NO ACTIVADO
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);

  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);

  const [oT, setoT] = useState(appColors['ColorX']);
  const [oG, setoG] = useState(appColors['ColorG2']);

  const [OnT, setOnT] = useState(appColors['ColorX']);
  const [OnG, setOnG] = useState(appColors['ColorG2']);

  const [ONET, setONET] = useState(appColors['ColorX']);
  const [ONG, setONG] = useState(appColors['ColorG2']);

  const [TWT, setTWT] = useState(appColors['ColorX']);
  const [TWG, setTWG] = useState(appColors['ColorG2']);

  const [THT, setTHT] = useState(appColors['ColorX']);
  const [THG, setTHG] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'cinco') {
      setoT('white');
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
      setoG(appColors['ColorX']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
    } else if (key === 'seis') {
      setOnT('white');
      setOnG(appColors['ColorX']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
    } else if (key === 'siete') {
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setONET('white');
      setONG(appColors['ColorX']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
    } else if (key === 'ocho') {
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT('white');
      setTWG(appColors['ColorX']);
      setTHT(appColors['ColorX']);
      setTHG(appColors['ColorG2']);
    } else if (key === 'nueve') {
      setOnT(appColors['ColorX']);
      setOnG(appColors['ColorG2']);
      setoT(appColors['ColorX']);
      setoG(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setONET(appColors['ColorX']);
      setONG(appColors['ColorG2']);
      setTWT(appColors['ColorX']);
      setTWG(appColors['ColorG2']);
      setTHT('white');
      setTHG(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>1</Button>, key: 'uno', children: <Uno/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>2</Button>, key: 'dos', children: <Dos/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>3</Button>, key: 'tres', children: <Tres/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>4</Button>, key: 'cuatro', children: <Cuatro/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: oT, fontWeight: 'bold', borderColor: oG, background: oG}}>5</Button>, key: 'cinco', children: <Cinco/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: OnT, fontWeight: 'bold', borderColor: OnG, background: OnG}}>6</Button>, key: 'seis', children: <Seis/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: ONET, fontWeight: 'bold', borderColor: ONG, background: ONG}}>7</Button>, key: 'siete', children: <Siete/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TWT, fontWeight: 'bold', borderColor: TWG, background: TWG}}>8</Button>, key: 'ocho', children: <Ocho/>},
    {label: <Button style={{width: '11vh', height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: THT, fontWeight: 'bold', borderColor: THG, background: THG}}>9</Button>, key: 'nueve', children: <Nueve/>},
  ];
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='1vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default SUGMDTabs;
